<template>
  <chart-card title="Percentual do cupons fidelidade" filter-button :filter-type.sync="filterType" :data="chartData" :chart-loading="loading" is-percent />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  name: 'PercentualCuponsChart',
  components: {
    ChartCard,
  },
  data: () => ({
    filterType: 'mensal',
    percentualCupons: [],
    loading: true,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filtro() {
      return {
        unidades: this.stateFilters.unitsConfiguration,
        fidelidade: '1',
        segmentos: this.stateFilters.segments,
      }
    },
    chartData() {
      return {
        labels: [...this.percentualCupons.map((object) => object.data)],
        datasets: [
          {
            label: 'Percentual cupons no clube',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.percentualCupons.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
  watch: {
    filterType() {
      this.getData()
    },
  },
  async mounted() {
    this.$bus.$on('filter', this.getData)

    this.$nextTick(async () => {
      await this.getData()
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      clubePercentualCuponsFidelidade: 'percentual-cupons',
    }),
    async getData() {
      try {
        this.loading = true
        if (this.filterType === 'mensal') {
          await this.clubePercentualCuponsFidelidade({ group_field: 'ano,mes', ...this.filtro }).then((data) => {
            this.percentualCupons = helpers.agrupamentoMensal(data, 'PER_CUPONS_FIDELIDADE')
          })
        }

        if (this.filterType === 'semanal') {
          await this.clubePercentualCuponsFidelidade({ group_field: 'ano,semana', ...this.filtro }).then((data) => {
            this.percentualCupons = helpers.agrupamentoSemanal(data, 'PER_CUPONS_FIDELIDADE')
          })
        }

        if (this.filterType === 'diario') {
          await this.clubePercentualCuponsFidelidade({ group_field: 'anomesdia', ...this.filtro }).then((data) => {
            this.percentualCupons = helpers.agrupamentoDiario(data, 'PER_CUPONS_FIDELIDADE')
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
